import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { createApi } from "@reduxjs/toolkit/query/react";
import { apiBaseQuery } from "../common/utils/apiBaseQuery";

export interface RootInterface {
    authToken?: string;
    establishmentId?: number;
    employeeId?: number;
    activeEstablishmentId?: number;
    isMenuOpen: boolean;
}

const initialState: RootInterface = {
    authToken: undefined,
    establishmentId:
        localStorage.getItem("activeEstablishmentId") !== null
            ? Number.parseInt(
                  localStorage.getItem("activeEstablishmentId")!,
                  10,
              )
            : undefined,
    activeEstablishmentId:
        localStorage.getItem("activeEstablishmentId") !== null
            ? Number.parseInt(
                  localStorage.getItem("activeEstablishmentId")!,
                  10,
              )
            : undefined,
    isMenuOpen: false,
};

export const rootSlice = createSlice({
    name: "root",
    initialState,
    reducers: {
        setAuthToken: (state, action: PayloadAction<string>) => {
            state.authToken = action.payload;
        },
        setEstablishmentId: (state, action: PayloadAction<number>) => {
            state.establishmentId = action.payload;
        },
        setEmployeeId: (state, action: PayloadAction<number>) => {
            state.employeeId = action.payload;
        },
        unsetEstablishmentId: (state) => {
            localStorage.removeItem("activeEstablishmentId");
            state.establishmentId = undefined;
            state.activeEstablishmentId = undefined;
        },
        setActiveEstablishmentId: (state, action: PayloadAction<number>) => {
            localStorage.setItem(
                "activeEstablishmentId",
                action.payload.toString(),
            );
            state.establishmentId = action.payload;
            state.activeEstablishmentId = action.payload;
        },
        setIsMenuOpen: (state, action: PayloadAction<boolean>) => {
            state.isMenuOpen = action.payload;
        },
    },
});

export const rootApiSlice = createApi({
    reducerPath: "rootApi",
    baseQuery: apiBaseQuery(),
    tagTypes: [],
    endpoints: () => ({}),
});

export const {
    setAuthToken,
    setEstablishmentId,
    setEmployeeId,
    unsetEstablishmentId,
    setActiveEstablishmentId,
    setIsMenuOpen,
} = rootSlice.actions;

export default rootSlice.reducer;
